import "./ContactFormStyles.css"

import React, { useRef } from 'react'

import emailjs from '@emailjs/browser';

//npm install @emailjs/browser --save

//e.target.reset()

//form.reset

const ContactForm = () => {
    const form = useRef();
  
    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, form.current, process.env.REACT_APP_PUBLIC_KEY)
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        
        alert("Mensaje enviado 💕");

        e.target.reset();
        
    };
  
    return (
        <div className="form">
            <form ref={form} onSubmit={sendEmail}>
                <label>Tu nombre *</label>
                <input required type="text" name="user_name" placeholder="Ej: Jon Snow"/>
                <label>Tu email *</label>
                <input required type="email" name="user_email" placeholder="Ej: jon@snow.com"/>
                <label>Tu mensaje *</label>
                <textarea required name="message" rows="6" placeholder="Escribe tu mensaje aquí"/>
                <input type="submit" value="Enviar" className="btn"/>
            </form>
        </div>
        
    );
  };

export default ContactForm